import styled from 'styled-components';
import { lightGrey1Color } from 'js/config/style';

export default styled.div`
  text-align: center;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  grid-template-areas: '. menu .';
  background: ${lightGrey1Color};
`;
